import styles from './CollapsiblePanel.module.css';
import { ReactNode, useMemo } from 'react';

export interface CollapsiblePanelProps {
  children: ReactNode;
  open: boolean;
  openedPanelHeight: string;
}

interface DynamicStyles {
  [key: string]: string;
}

const getWrapperStyle = (openedPanelHeight: string): DynamicStyles => ({
  '--expanded-height': openedPanelHeight,
});

const CollapsiblePanel = ({ children, open, openedPanelHeight }: CollapsiblePanelProps) => {
  const style = useMemo(() => getWrapperStyle(openedPanelHeight), [openedPanelHeight]);

  const panelClasses = `${styles.collapsiblePanel} ${open ? styles.expanded : styles.collapsed}`;

  return (
    <div className={panelClasses} style={style} data-testid="collapsible-panel" aria-hidden={!open}>
      {children}
    </div>
  );
};

export default CollapsiblePanel;
